import {
  Divider, List,
} from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import DrawIcon from '@mui/icons-material/Draw';
import NotificationsIcon from '@mui/icons-material/Notifications';
import FolderIcon from '@mui/icons-material/Folder';
import PersonIcon from '@mui/icons-material/Person';
import CalculateIcon from '@mui/icons-material/Calculate';
import BuildIcon from '@mui/icons-material/Build';
import LinkIcon from '@mui/icons-material/Link';
import SettingsIcon from '@mui/icons-material/Settings';
import PeopleIcon from '@mui/icons-material/People';
import TodayIcon from '@mui/icons-material/Today';
import SendIcon from '@mui/icons-material/Send';
import DnsIcon from '@mui/icons-material/Dns';
import HelpIcon from '@mui/icons-material/Help';
import PaymentIcon from '@mui/icons-material/Payment';
import CampaignIcon from '@mui/icons-material/Campaign';
import GridViewIcon from '@mui/icons-material/GridView';
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Map from '@mui/icons-material/Map';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PlaceIcon from '@mui/icons-material/Place';
import RouteIcon from '@mui/icons-material/Route';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from '../../common/components/LocalizationProvider';
import {
  useAdministrator, useManager, useRestriction, useSuperAdmin,
} from '../../common/util/permissions';
import useFeatures from '../../common/util/useFeatures';
import MenuItem from '../../common/components/MenuItem';

const SettingsMenu = () => {
  const t = useTranslation();
  const location = useLocation();

  const readonly = useRestriction('readonly');
  const admin = useAdministrator();
  const manager = useManager();
  const superAdmin = useSuperAdmin();
  const userId = useSelector((state) => state.session.user.id);
  const supportLink = useSelector((state) => state.session.server.attributes.support);
  const billingLink = useSelector((state) => state.session.user.attributes.billingLink);

  const features = useFeatures();

  return (
    <>
      <List>
        <MenuItem
          title={t('dashboardMenuText')}
          link="/settings/dashboard"
          icon={<GridViewIcon />}
          selected={location.pathname === '/settings/dashboard'}
        />
         <MenuItem
          title={t('mapTitle')}
          link="/"
          icon={<Map/>}
          // selected={location.pathname === '/settings/preferences'}
        />
        <MenuItem
          title={t('sharedPreferences')}
          link="/settings/preferences"
          icon={<TuneIcon />}
          selected={location.pathname === '/settings/preferences'}
        />
        <MenuItem
          title={t('fleetDashboard')}
          link="/fleet"
          icon={<LocalShippingIcon />}
          selected={location.pathname === '/fleet'}
        />
        <MenuItem
          title={t('temperatureMonitor')}
          link="/temperature"
          icon={<ThermostatIcon />}
          selected={location.pathname === '/temperature'}
        />
        <MenuItem
          title={t('reportManagement')}
          link="/reports/management/speeding"
          icon={<AssessmentIcon />}
          selected={location.pathname.startsWith('/reports/management')}
        />
        {admin && (
          <MenuItem
            title={t('configuratorTitle')}
            link="/settings/configurator"
            icon={<SettingsRemoteIcon />}
            selected={location.pathname === '/settings/configurator'}
          />
        )}
        <MenuItem
          title={t('assistantTitle')}
          link="/assistant"
          icon={<SmartToyIcon />}
          selected={location.pathname === '/assistant'}
        />
        {!readonly && (
          <>
            <MenuItem
              title={t('sharedNotifications')}
              link="/settings/notifications"
              icon={<NotificationsIcon />}
              selected={location.pathname.startsWith('/settings/notification')}
            />
            <MenuItem
              title={t('settingsUser')}
              link={`/settings/user/${userId}`}
              icon={<PersonIcon />}
              selected={location.pathname === `/settings/user/${userId}`}
            />
            <MenuItem
              title={t('deviceTitle')}
              link="/settings/devices"
              icon={<DnsIcon />}
              selected={location.pathname.startsWith('/settings/device')}
            />
            <MenuItem
              title={t('sharedGeofences')}
              link="/geofences"
              icon={<DrawIcon />}
              selected={location.pathname.startsWith('/settings/geofence')}
            />
            <MenuItem
              title={t('poiTitle')}
              link="/settings/pois"
              icon={<PlaceIcon />}
              selected={location.pathname.startsWith('/settings/poi')}
            />
            <MenuItem
              title={t('sharedRoutes') || 'Rotas'}
              link="/settings/routes"
              icon={<RouteIcon />}
              selected={location.pathname.startsWith('/settings/route') && !location.pathname.includes('route-planning')}
            />
            <MenuItem
              title={t('routePlanning') || 'Roteirizacao'}
              link="/settings/route-planning"
              icon={<AltRouteIcon />}
              selected={location.pathname === '/settings/route-planning'}
            />
            <MenuItem
              title={t('routingDashboard') || 'Dashboard Rotas'}
              link="/settings/routing-dashboard"
              icon={<AssessmentIcon />}
              selected={location.pathname === '/settings/routing-dashboard'}
            />
            <MenuItem
              title={t('routeExecution') || 'Execucao de Rotas'}
              link="/settings/route-execution"
              icon={<LocalShippingIcon />}
              selected={location.pathname.startsWith('/settings/route-execution')}
            />
            <MenuItem
              title={t('operationsCenter') || 'Central de Operacoes'}
              link="/settings/operations-center"
              icon={<DnsIcon />}
              selected={location.pathname === '/settings/operations-center'}
            />
            <MenuItem
              title={t('driverActivity') || 'Atividade Motoristas'}
              link="/settings/driver-activity"
              icon={<PersonIcon />}
              selected={location.pathname === '/settings/driver-activity'}
            />
            {!features.disableGroups && (
              <MenuItem
                title={t('settingsGroups')}
                link="/settings/groups"
                icon={<FolderIcon />}
                selected={location.pathname.startsWith('/settings/group')}
              />
            )}
            {!features.disableDrivers && (
              <MenuItem
                title={t('sharedDrivers')}
                link="/settings/drivers"
                icon={<PersonIcon />}
                selected={location.pathname.startsWith('/settings/driver')}
              />
            )}
            {!features.disableCalendars && (
              <MenuItem
                title={t('sharedCalendars')}
                link="/settings/calendars"
                icon={<TodayIcon />}
                selected={location.pathname.startsWith('/settings/calendar')}
              />
            )}
            {!features.disableComputedAttributes && (
              <MenuItem
                title={t('sharedComputedAttributes')}
                link="/settings/attributes"
                icon={<CalculateIcon />}
                selected={location.pathname.startsWith('/settings/attribute')}
              />
            )}
            {!features.disableMaintenance && (
              <MenuItem
                title={t('sharedMaintenance')}
                link="/settings/maintenances"
                icon={<BuildIcon />}
                selected={location.pathname.startsWith('/settings/maintenance')}
              />
            )}
            <MenuItem
              title={t('sharedCorrelations')}
              link="/settings/correlations"
              icon={<LinkIcon />}
              selected={location.pathname.startsWith('/settings/correlation')}
            />
            {!features.disableSavedCommands && (
              <>
                <MenuItem
                  title={t('sharedSavedCommands')}
                  link="/settings/commands"
                  icon={<SendIcon />}
                  selected={location.pathname.startsWith('/settings/command')}
                />
                <MenuItem
                  title={t("sharedCosts")}
                  link="/settings/costs"
                  icon={<AttachMoneyIcon />}
                  selected={location.pathname.startsWith("/settings/cost")}
                />
              </>
            )}
        {billingLink && (
          <MenuItem
            title={t('userBilling')}
            link={billingLink}
            icon={<PaymentIcon />}
          />
        )}
        {supportLink && (
          <MenuItem
            title={t('settingsSupport')}
            link={supportLink}
            icon={<HelpIcon />}
          />
        )}
          </>
        )}
      </List>
      {manager && (
        <>
          <Divider />
          <List>
            <MenuItem
              title={t('serverAnnouncement')}
              link="/settings/announcement"
              icon={<CampaignIcon />}
              selected={location.pathname === '/settings/announcement'}
            />
            {admin && (
            <>
              <MenuItem
                title={t('settingsServer')}
                link="/settings/server"
                icon={<SettingsIcon />}
                selected={location.pathname === '/settings/server'}
              />
            </>
            )}
            {superAdmin && (
            <>
              <MenuItem
                title={t('tagsAdmin') || 'Tags BLE/GPS'}
                link="/settings/tags"
                icon={<LocalOfferIcon />}
                selected={location.pathname === '/settings/tags'}
              />
{/*               <MenuItem */}
{/*                 title={t('licensesTitle')} */}
{/*                 link="/settings/licenses" */}
{/*                 icon={<CardMembershipIcon />} */}
{/*                 selected={location.pathname === '/settings/licenses'} */}
{/*               /> */}
{/*               <MenuItem */}
{/*                 title={t('sharedRevenda')} */}
{/*                 link="/revendas" */}
{/*                 icon={<RevendasIcon />} */}
{/*                 selected={location.pathname.startsWith('/settings/revendas')} */}
{/*               /> */}
{/*               <MenuItem */}
{/*                 title={t("sharedWhatsapp")} */}
{/*                 link="/settings/whatsapp" */}
{/*                 icon={<WhatsAppIcon />} */}
{/*                 selected={location.pathname === "/settings/whatsapp"} */}
{/*               /> */}
            </>
            )}
            <MenuItem
              title={t('settingsUsers')}
              link="/settings/users"
              icon={<PeopleIcon />}
              selected={location.pathname.startsWith('/settings/user') && location.pathname !== `/settings/user/${userId}`}
            />
          </List>
        </>
      )}
        {/*{admin && (
          <>
            <Divider />
            <List>
              <ListSubheader className={classes.desktopDrawer} component="div" id="nested-list-subheader">
                {t('sharedExtra')}
              </ListSubheader>
              <MenuItem
                title={t('sharedUpdates')}
                link="/settings/updates"
                icon={<NewReleasesIcon />}
                selected={location.pathname === '/settings/updates'}
              />
            </List>
          </>
        )} */}
    </>
  );
};

export default SettingsMenu;
